<template>
  <div class="sorting-select">
    <vb-dropdown
      :vb_options="{
        text: current_label,
        size: 'sm',
        right: true,
      }"
    >
      <b-dropdown-item
        v-for="(option, index) in options"
        :key="`sort-${index}`"
        :active="option.value === sort"
        @click="$emit('order', option.value)"
      >
        {{ option.text }}
      </b-dropdown-item>
    </vb-dropdown>
  </div>
</template>

<script>
  import { SORT_OPTIONS } from '@alpitour/utilities/results-sorting';

  export default {
    name: 'sorting-select',

    props: {
      sort: {
        type: String,
        default: '',
      },
    },

    data() {
      return {
        options: SORT_OPTIONS,
      };
    },

    computed: {
      current_label() {
        const selected = this.options.find(
          (option) => option.value === this.sort,
        );
        return selected ? selected.text : 'Ordina per';
      },
    },
  };
</script>

<style lang="scss" scoped>
  .sorting-select {
    display: flex;

    ::v-deep .vb-dropdown {
      .btn {
        display: flex;
        align-items: center;
        background-color: $white !important;
        color: $dark !important;
        border: 1px solid $gray-300 !important;
        box-shadow: none !important;
        font-size: $font-size-md;
        line-height: normal;
        padding-left: $grid-gutter-width / 2;
        padding-right: $grid-gutter-width / 2;

        &:hover,
        &:focus,
        &:active,
        &:not(:disabled):not(.disabled):active {
          background-color: $gray-100 !important;
        }

        &::after {
          content: '';
          display: block;
          flex-shrink: 0;
          width: 14px !important;
          height: 14px !important;
          border: 0;
          margin-left: $grid-gutter-width / 3 !important;
          background-image: escape-svg($custom-select-indicator) !important;
          background-repeat: no-repeat;
          background-position: center !important;
          background-size: contain !important;
        }
      }

      .dropdown-menu {
        border: 1px solid $gray-200;
        border-radius: $border-radius-lg;
        font-size: $font-size-md;
        margin: 0;
        padding: $grid-gutter-width / 4 0;
      }

      .dropdown-item {
        color: inherit;

        &.active,
        &:active {
          background-color: transparent;
          color: var(--primary);
        }
      }
    }
  }
</style>
